import axios from 'axios';

import type { HostGroupWithMetaData, Site } from './core.types';

export async function getSitesByTeam(teamId: string): Promise<Array<Site>> {
  const { data } = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/${teamId}/sites`);
  return data;
}

export async function readAllSineHostGroups(
  limit: number,
  offset: number,
  searchTerm?: string,
  siteId?: string,
): Promise<HostGroupWithMetaData> {
  const res = await axios.get<{ hostGroups: HostGroupWithMetaData }>(
    `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/host/group/search?`,
    {
      params: {
        name: searchTerm,
        siteId,
        limit,
        offset,
      },
    },
  );

  return res.data.hostGroups;
}
